import { mask } from 'remask';
import { Moment } from 'moment';
import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { DATE_MASK } from '@app/shared/utils/moment-adapter.util';

export interface DateOptions {
  minDate?: Moment;
  maxDate?: Moment;
  icon?: 'prefix' | 'suffix';
}

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class DateInputComponent {
  @Input()
  appearance?: 'fill' | 'outline' = 'outline';
  
  @Input()
  label: string = '';

  @Input()
  name: string = '';

  @Input()
  dateOptions?: DateOptions = { icon: 'suffix' };

  get control() {
    return this.formGroupDirective.form.get(this.name);
  }

  constructor(private formGroupDirective: FormGroupDirective) { }

  onChange(event: any) {
    event.target.value = mask(event.target.value, DATE_MASK);
  }

  onBlur() {
    if(this.control && this.control.invalid) {
      this.control.setValue('', { emitEvent: false, onlySelf: true });
    }
  }
}
